import { render, staticRenderFns } from "./intelSortSubscribe.vue?vue&type=template&id=b8c13ad8&scoped=true"
import script from "./intelSortSubscribe.vue?vue&type=script&lang=js"
export * from "./intelSortSubscribe.vue?vue&type=script&lang=js"
import style0 from "./intelSortSubscribe.vue?vue&type=style&index=0&id=b8c13ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c13ad8",
  null
  
)

export default component.exports